import { Component, Input } from '@angular/core';

@Component({
  selector: 'bst-description-fit-warning',
  template: `
    <span class="description-fit-warning-chip"
          *ngIf="show"
          [nbTooltip]="'matching.description_fit_warning.tooltip' | translate">
      <nb-icon icon="alert-triangle-outline" class="warning-icon"></nb-icon>
      <small>{{ 'matching.description_fit_warning.label' | translate }}</small>
    </span>
  `,
  styles: [`
    .description-fit-warning-chip {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 2px 8px;
      border-radius: 12px;
      background: var(--color-warning-transparent-100, #fff4e6);
      color: var(--color-warning-600, #b45309);
      font-size: 0.75rem;
      white-space: nowrap;
    }
    .warning-icon {
      font-size: 14px;
      width: 14px;
      height: 14px;
    }
  `],
  standalone: false,
})
export class DescriptionFitWarningComponent {
  @Input() show = false;
}
